





































































import { defineComponent, ref } from "@nuxtjs/composition-api";
import { Carousel, Slide } from "vue-carousel";
import PBHelper from "~/components/PageBuilder/utils/helper";
import { json2html } from "html2json_2";

export default defineComponent({
  name: "MediaSlider",
  components: {
    Carousel,
    Slide,
  },
  props: {
    tag: {
      type: String,
      default: "div",
    },
    node: {
      type: String,
      default: "div",
    },
    attr: {
      type: Object,
      default: () => {},
    },
    children: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    // carousel
    const carouselOptions = ref({
      perPage: 1,
    });
    // background images
    const dynamicBackgroundImages = ref([]);
    const { createDynamicBackgroundImage } = PBHelper();
    props.children.forEach((item, key) => {
      const backgroundImage =
        item["child"][0]["child"][0]["attr"]["data-background-images"];
      const dynamicBackgroundImage =
        createDynamicBackgroundImage(backgroundImage);
      dynamicBackgroundImages.value[key] = dynamicBackgroundImage;
    });

    const sliderItems = ref([]);

    const pb = {children: props.children};
    sliderItems.value = pb.children;

    return {
      json2html,
      carouselOptions,
      sliderItems,
      dynamicBackgroundImages,
    };
  },
});
